module.exports = __webpack_public_path__ + "static/media/tshirt-design.3fdcb03f.png";